
export const infoByAFMIinitialValues = {
  afm: ''
};

export const infoByNameIinitialValues = {
  surnameA: '',
  nameA: '',
  fathersFirstName: ''
};

export const infoByADTIinitialValues = {
  adt: '',
  kind: '',
};

export const confirmBanlIinitialValues = {
  afm: '',
  iban: ''
};

export const infoByAMKAIinitialValues = {
  amka: ''
};

export const amkaByInfoInitialValues = {
  surname: '',
  firstName: '',
  fatherName: '',
  afm: ''
};

export const retrieveForesInfoInitialValues = {
  afm: ''
};

export const retrieveParavolaInfoInitialValues = {
  afm: '',
  foreasId: '',
  categoryId: '',
  dateFrom: '',
  dateTo: ''
};
export const categoriesInfoInitialValues = {
  foreasCode: ''
};
export const typesInfoInitialValues = {
  categoryCode: ''
};

export const userDetailsAFMIinitialValues = {
  afm: ''
};

export const paravoloTypeIinitialValues = {
  typeId: ''
};

export const paravoloStatusIinitialValues = {
  paravoloPaymentCode: ''
};

export const createParavoloInitialValues: { [key: string]: string } = {
  typeCode: '',
  paravoloAmount: '',
  afm: '',
  firstName: '',
  lastName: '',
  fatherName: '',
  motherName: '',
  iban: '',
  sendEmail: '',
  emailAddress: '',
  mobilePhone: '',
  birthDate: '',
  additionalInfo: '',
};

export const createParavoloShortInitialValues = {
  typeCode: '',
  paravoloAmount: '',
  afm: '',
  firstName: '',
  lastName: '',
  fatherName: '',
};

export const validateGemiAFMInitialValues = {
  afm: '',
};
export const validateGemiBranchInitialValues = {
  afm: '',
  arGemi: ''
};

export const gemiBoardInitialValues = {
  arGemi: '',
};

export const gemiBoardV3InitialValues = {
  arGemi: '',
  afm: ''
};

export const gemiBasicInfoInitialValues = {
  arGemi: '',
};

export const gemiBasicInfoV3InitialValues = {
  arGemi: '',
  afm: ''
};

export const afeValidationInitialValues = {
  rvAfeType: '',
  rvAfeDoy: '',
  rvAfeAa: '',
  rvAfeYear: '',
  rvAfeAfm: ''
};

export const afeIssueValidationInitialValues: { [key: string]: string } = {
  afeAfm: '',
  afeIssuedByAfm: '996973308',
  afeEmployeeAfm: '',
  afeIssuedByDescr: '',
  afeReason: '',
  afeText: '',
  afeForeas: '',
  afePdfRequested: '',
};

export const aadeKadIinitialValues = {
  afm: '',
  dateFrom: '',
  dateTo: ''
};

export const interoperabilityDashboardIinitialValues = {
  user_id: '',
  interoperability_id: '',
  dateFrom: '',
  dateTo: ''
};